'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getActiveSettingsEditorCategory } from 'DesignData/selectors/app';
import { SETTINGS } from 'DesignData/enums/DesignAssetTypes';
import * as SettingsCategories from 'DesignData/enums/settings/Categories';
import EditorOptions from 'DesignData/models/app/EditorOptions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterButtonLink from 'ui-addon-react-router-dom/UIRouterButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import { createPath } from 'DesignData/helpers/routingHelper';
const iconsMap = {
  [SettingsCategories.NONE]: 'settings',
  [SettingsCategories.CODE]: 'code',
  [SettingsCategories.JSLINT]: 'jsFile'
};
const routeOptionsMap = {
  [SettingsCategories.NONE]: new EditorOptions({
    settingsCategory: SettingsCategories.NONE
  }),
  [SettingsCategories.CODE]: new EditorOptions({
    settingsCategory: SettingsCategories.CODE
  }),
  [SettingsCategories.JSLINT]: new EditorOptions({
    settingsCategory: SettingsCategories.JSLINT
  })
};
const navigationOrder = [SettingsCategories.NONE, SettingsCategories.CODE, SettingsCategories.JSLINT];

function mapStateToProps(state) {
  return {
    settingsCategory: getActiveSettingsEditorCategory(state)
  };
}

class Navigation extends PureComponent {
  renderCategoryI18n(cat, field = 'title') {
    const message = `designManager.settings.categories.${cat}.${field}`;
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    }, cat);
  }

  renderCategoryLink(cat, isActive) {
    const path = createPath(SETTINGS, 'settings', routeOptionsMap[cat]);
    const cx = 'settings-category-link' + (isActive ? " is--active" : "");
    return /*#__PURE__*/_jsxs(UIRouterButtonLink, {
      className: cx,
      to: path,
      disabled: isActive,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: iconsMap[cat]
      }), "\xA0", this.renderCategoryI18n(cat, 'subtitle')]
    }, cat);
  }

  renderListItems() {
    const {
      settingsCategory
    } = this.props;
    return navigationOrder.map(cat => {
      return this.renderCategoryLink(cat, settingsCategory === cat);
    });
  }

  render() {
    const {
      settingsCategory
    } = this.props;
    return /*#__PURE__*/_jsx(UIDropdown, {
      className: "settings-column settings-navigation-column",
      buttonSize: "extra-small",
      buttonText: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'designManager.settings.title'
        }), ":", ' ', this.renderCategoryI18n(settingsCategory, 'subtitle')]
      }),
      iconName: iconsMap[settingsCategory],
      children: /*#__PURE__*/_jsx(UIList, {
        children: this.renderListItems()
      })
    }, "settings-navigation");
  }

}

Navigation.propTypes = {
  settingsCategory: PropTypes.oneOf(Object.values(SettingsCategories || {})).isRequired
};
export default connect(mapStateToProps)(Navigation);